export default {
    methods: {
        /**
         * Show a info notification
         * Uses Modal
         */
        infoNotification(title, message) {

            this.$bvModal.msgBoxConfirm(message, {
                title: title,
                // size: 'sm',
                // buttonSize: 'sm',
                okVariant: 'success',
                cancelVariant: 'hidden',
                okTitle: 'Ok',
                cancelTitle: 'No',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true,
                noFade: true,
                hideCancelButton: true,
            })
                .then(value => {
                    // close
                })
                .catch(err => {
                    // An error occurred
                })
        }
    }
};